import LoginTopBanner from "../../layout/AuthLayout/authTopbanner";
import LoginBanner from "../../assests/new-images/banner.webp";
import FEATURE_CONFIG from "client/feature.config.json";
import { useTranslation } from "react-i18next";
import BGSlide from "../../assests/new-images/BG_SLIDE.png";
import { useNavigate } from "react-router";

export default function AuthLayout1({ children, module, title }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div className="auth-layout">
        <div className="container-section">
          {FEATURE_CONFIG.LOGIN_TOP_BANNER && (
            <LoginTopBanner module={module} title={title} />
          )}
          <div className="auth-render-section">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 ">
                <div className="" >
                  {children}
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 hide-xs">
                <div
                  className=" text-center"
                  style={{ width: 494, margin: "0 auto" }}
                >
                  <img src={LoginBanner} height={500} className="right-banner"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
